import React from 'react';

import { OnlyMainColumnMaxWidth } from '@townsquare/home-layout/constants';
import { MainColumn, AsideColumn } from '@townsquare/responsive-grid/responsive-grid';
import { SidebarSectionSkeleton } from '@townsquare/sidebar-section';
import { useIsNavRefreshEnabled } from '@townsquare/stat-sig/nav4';

import { UpdateListSkeleton, FeedTitleSkeleton } from '../components/Skeletons';
import { SidebarContainer } from '../components/UpdatesFeeds/styles';

export const SavedViewUpdatesViewSkeleton = () => {
  const isNavRefreshEnabled = useIsNavRefreshEnabled();

  const mainContent = (
    <>
      <FeedTitleSkeleton />
      <UpdateListSkeleton />
    </>
  );

  if (isNavRefreshEnabled) {
    return mainContent;
  }

  return (
    <>
      <MainColumn maxWidthPx={OnlyMainColumnMaxWidth}>{mainContent}</MainColumn>
      <AsideColumn>
        <SidebarContainer>
          <SidebarSectionSkeleton rows={3} />
        </SidebarContainer>
      </AsideColumn>
    </>
  );
};
